/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import { filterSelectOptions } from '../../DynamicFormNew/helper';
import NetworkChart3 from '../Widgets/NetworkChart/index3';
import { DashboardService } from '../../../services';
import { config } from '../config';

export const defaultTrade = {
  apiCall: false,
  name: "Name Placeholder",
  title: "Negociant",
  color: "#0F4C75",
  parent: "92f8420d-9884-40b2-87d6-14beefd3deb7",
  dashed: true,
  children: [
    {
      title: "Exporter",
      name: "Name Placeholder",
      parent: "4a2d9a45-a17c-46ef-a5b7-ec603b85c811",
      id: "678cebf7-80ce-48b7-a62b-91da48f5b578",
      children: [],
      parents: [],
      color: "#3282B8",
      dashed: true,
    },
    {
      title: "Exporter",
      name: "Name Placeholder",
      parent: "4a2d9545-a17c-46ef-a5b7-ec603b85c811",
      id: "678cebf7-80ce-48b7-a62b-91da48f5b578",
      children: [],
      parents: [],
      color: "#3282B8",
      dashed: true,
    },
    {
      title: "Exporter",
      name: "Name Placeholder",
      parent: "4a2d9645-a17c-46ef-a5b7-ec603b85c811",
      id: "678cebf7-80ce-48b7-a62b-91da48f5b578",
      children: [],
      parents: [],
      color: "#3282B8",
      namespace: "scp",
      dashed: true,
    },
  ],
  parents: [
    {
      title: "Cooperative",
      name: "Name Placeholder",
      parent: "c8fc7f06-942e-4497-8282-6aeb0ac62c86",
      color: "#1B262C",
      dashed: true,
    },
  ],
}

export default function TradeRelationShip({
  trade,
  loadGraph,
  showSelects = true,
  showTradeType = true,
  module = 'pme',
  emptyStateIsShown = true,
  setEmptyStateIsShown = () => { },
  sourceId,
  selectedProject,
}) {
  const { t } = useTranslation();
  const loading = !trade;
  const [selectedTradeType, setSelectedTradeType] = useState(
    selectedProject === 'myOwnData' ? localStorage.getItem('trade-type') : undefined
  );
  const [selectedTradeValue, setSelectedTradeValue] = useState(
    selectedProject === 'myOwnData' ? localStorage.getItem('trade-value') : undefined
  );
  const [tradeOptions, setTradeOptions] = useState([])
  const [invParties, setInvolvetParties] = useState([])
  const [tradeData, setTradeData] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [initTrade, setInitTrade] = useState(false);

  useEffect(() => {
    if (sourceId) {
      if (initTrade) {
        setInitTrade(false);
      }
    }
  }, [sourceId, selectedProject]);

  useEffect(() => {
    if (!initTrade) {
      if (selectedTradeType && trade) {
        const allTradeOptions = trade.filter(t => t.type === selectedTradeType);
        setTradeOptions(allTradeOptions);
        setInitTrade(true);
        if (selectedTradeValue) {
          const tOption = allTradeOptions.find(to => to.id === selectedTradeValue) || {};
          if (tOption) {
            setTradeDataConfig(tOption, 'select');
          } else {
            setSelectedTradeValue(undefined);
          }
        }
      }
    }
  }, [trade, initTrade]);

  useEffect(() => {
    if (selectedTradeValue) {
      if (emptyStateIsShown) {
        setEmptyStateIsShown(false);
      }
    } else {
      if (!emptyStateIsShown) {
        setTradeDataConfig(defaultTrade);
        setEmptyStateIsShown(true);
      }
    }
  }, [selectedTradeValue]);

  const setTradeDataConfig = (option) => {
    const {
      id,
      apiCall,
      involvedParties = [],
    } = option;
    if (!showTradeType) {
      setTradeOptions(trade);
    }
    setTradeData(null);
    if (apiCall) {
      setIsLoading(true);
      DashboardService.getTradeRelationShip(id).then((res) => {
        if (res.data) {
          setTradeData(res.data || {});
          setInvolvetParties(res.data.involvedParties);
        } else {
          setTradeData(option || {});
          setInvolvetParties(involvedParties);
        }
        setIsLoading(false);
        setEmptyStateIsShown(false);
      }).catch(err => {
        console.log(err);
        setTradeData(option || {});
        setInvolvetParties(involvedParties);
        setIsLoading(false);
      })
    } else {
      setTimeout(() => {
        setTradeData(option || defaultTrade);
        setInvolvetParties(involvedParties);
        setSelectedTradeValue(id);
      }, 500);
    }
  }

  useEffect(() => {
    if (module === 'cadd' && trade?.length) {
      setTradeDataConfig(trade[0], 'cadd');
    } else if (!selectedTradeValue) {
      setTradeDataConfig(defaultTrade, 'default');
    }
  }, [module, trade]);

  useEffect(() => {
    if (showSelects && showTradeType && (!selectedTradeType || !selectedTradeValue)) {
      setTradeDataConfig(defaultTrade, [showSelects, (!selectedTradeType && showTradeType), selectedTradeValue])
    }
  }, [selectedTradeType, selectedTradeValue])

  return <React.Fragment>
    {
      showSelects && <div className="column between" style={{
        width: '250px',
        height: '100%',
        background: 'white',
        borderRight: '1px solid rgba(0, 0, 0, 0.1)',
      }}>
        <div className="column between">
          <p style={{ margin: `${config.PADDING}px ${config.PADDING}px 0 ${config.PADDING}px`, color: '#A6ADB4' }}>{module === 'cadd' ? t('Focus Supplier') : t('Select a mining & mineral trade actor to map its supply chain')}</p>
          {showTradeType && <Select allowClear style={{ margin: config.PADDING }}
            onChange={val => {
              const allTradeOptions = (trade || []).filter(t => t.type === val);
              setSelectedTradeType(val);
              setTradeOptions(allTradeOptions);
              setSelectedTradeValue(undefined);
              setTradeData(null);
              if (selectedProject === 'myOwnData') {
                if (val) {
                  localStorage.setItem('trade-type', val);
                } else {
                  localStorage.removeItem('trade-type');
                }
              }
              setTimeout(() => {
                setTradeData({});
                setInvolvetParties([]);
              }, 300)
            }}
            value={selectedTradeType}
            placeholder={t("Select Type")}>
            <Select.Option value="miningOperator">{t('Mining Operators')}</Select.Option>
            <Select.Option value="localTrader">{t('Local Traders')}</Select.Option>
            <Select.Option value="exporter">{t('Exporters')}</Select.Option>
            <Select.Option value="globalBuyer">{t('Global Buyers')}</Select.Option>
          </Select>}
          <Select
            showSearch
            filterOption={filterSelectOptions}
            optionFilterProp="children"
            allowClear
            style={{ margin: `0px ${config.PADDING}px ${config.PADDING}px ${config.PADDING}px` }}
            value={(loading || tradeOptions.length === 0) ? undefined : selectedTradeValue}
            onChange={val => {
              const tOption = tradeOptions.find(to => to.id === val) || {};
              setSelectedTradeValue(val);
              if (selectedProject === 'myOwnData') {
                if (val) {
                  localStorage.setItem('trade-value', val);
                } else {
                  localStorage.removeItem('trade-value');
                }
              }
              setTradeDataConfig(tOption, 'select');
            }}
            placeholder={t("Select Entity")}>
            {tradeOptions.map((td, i) => (
              <Select.Option key={`${t.id}-${i}`} value={td.id}>{td.name}</Select.Option>
            ))}
          </Select>
        </div>
        <div
          className="column"
          style={{ padding: `0 ${config.PADDING}px ${config.PADDING}px ${config.PADDING}px` }}
        >
          {invParties && invParties.map((party, i) => (
            <div key={`party-${i}`} className="roww" style={{ marginTop: '5px', display: 'flex' }}>
              <div style={{ width: '15px', height: '15px', borderRadius: '3px', background: party.color, margin: 'auto 0' }}></div>
              <p style={{ margin: 'auto 8px' }}>{party.label}</p>
            </div>
          ))}
        </div>
      </div>
    }
    <div style={{ width: showSelects ? 'calc(100% - 250px)' : '100%', height: '100%' }}>
      {tradeData && loadGraph ? <NetworkChart3 isLoading={isLoading} module={module} tradeData={tradeData} /> : null}
    </div>
  </React.Fragment>
}
